import {COLORS} from "utils/constants";
import React from "react";

interface IconInterface {
  size?: number,
  color?: string
}

export const ArrowRight = ({size, color}: IconInterface) =>
  <svg style={{
    height: `${size}px`,
    width: `${size}px`,
    color: color ?? COLORS.primaryBlack
  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke={color ?? COLORS.primaryBlack}
       className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"/>
  </svg>


export const ArrowLeft = ({size, color}: IconInterface) =>
  <svg style={{
    height: `${size}px`,
    width: `${size}px`,
    color: color ?? COLORS.primaryBlack
  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke={color ?? COLORS.primaryBlack}
       className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"/>
  </svg>


export const ArrowUp = ({size, color}: IconInterface) =>
  <svg style={{
    height: `${size}px`,
    width: `${size}px`,
    color: color ?? COLORS.primaryBlack
  }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.8318 5.14077L11.8318 19.541" stroke="currentColor" strokeWidth="1.5" stroke-linecap="square"/>
    <path d="M5.8072 10.5918L11.8312 4.5418L17.8562 10.5918" stroke="currentColor" strokeWidth="1.5" stroke-linecap="square"/>
  </svg>


export const ArrowDown = ({size, color}: IconInterface) =>
  <svg style={{
    height: `${size}px`,
    width: `${size}px`,
    color: color ?? COLORS.primaryBlack
  }} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.8318 19.4413L11.8318 5.04102" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
    <path d="M17.8564 13.9902L11.8324 20.0402L5.80737 13.9902" stroke="currentColor" strokeWidth="1.5"
          strokeLinecap="square"/>
  </svg>


export const MapLocation = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size}px`,
    width: `${size}px`,
    color: color ?? COLORS.primaryBlack
  }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M14.232 9.70998C14.232 8.384 13.1575 7.30957 11.8325 7.30957C10.5066 7.30957 9.43213 8.384 9.43213 9.70998C9.43213 11.035 10.5066 12.1094 11.8325 12.1094C13.1575 12.1094 14.232 11.035 14.232 9.70998Z"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path fillRule="evenodd" clipRule="evenodd"
          d="M11.8313 22.1094C11.8313 18.5065 4.80896 15.3906 4.63201 9.68318C4.50777 5.67565 7.85472 2.10938 11.8313 2.10938C15.8079 2.10938 19.154 5.6756 19.0315 9.68318C18.8536 15.5077 11.8313 18.4101 11.8313 22.1094Z"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
)


export const Settings = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.8038 18.7156L18.3659 15.6753L21.2177 14.5345V9.46567L18.3669 8.32522L18.8049 5.28442L14.4152 2.75L12.0006 4.64979L9.5861 2.75L5.19636 5.28442L5.63427 8.32471L2.78223 9.46567V14.5345L5.63527 15.6759L5.19744 18.7156L9.58718 21.25L12.0006 19.3511L14.4141 21.25L18.8038 18.7156Z"
      stroke={color ?? COLORS.primaryBlack} strokeWidth="1.5" strokeLinecap="square"/>

    <path
      d="M12.0003 15.6876C14.0369 15.6876 15.6878 14.0366 15.6878 12C15.6878 9.96347 14.0369 8.3125 12.0003 8.3125C9.96371 8.3125 8.31274 9.96347 8.31274 12C8.31274 14.0366 9.96371 15.6876 12.0003 15.6876Z"
      stroke={color ?? COLORS.primaryBlack} strokeWidth="1.5" strokeLinecap="square"/>
  </svg>
)

export const QuestionCircle = ({size, color}:IconInterface) => (
  <svg style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color?? COLORS.primaryBlack
  }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M11.5861 2.6582C16.6941 2.6582 20.8361 6.7992 20.8361 11.9082C20.8361 17.0162 16.6941 21.1582 11.5861 21.1582C6.47706 21.1582 2.33606 17.0162 2.33606 11.9082C2.33606 6.7992 6.47706 2.6582 11.5861 2.6582Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.52356 9.74902C8.52356 8.74902 9.13606 6.74902 11.5861 6.74902C12.6069 6.81152 14.6486 7.57402 14.6486 10.124C14.6486 11.0824 14.0361 12.999 11.5861 12.999V14.4365" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M11.5811 16.7041H11.5911" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/>
  </svg>
)

export const PowerOff = ({size, color}:IconInterface) => (
  <svg style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color?? COLORS.primaryBlack
  }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M11.5272 21.0234C16.6359 21.0234 20.7772 16.8821 20.7772 11.7734C20.7772 6.6648 16.6359 2.52344 11.5272 2.52344C6.41859 2.52344 2.27722 6.6648 2.27722 11.7734C2.27722 16.8821 6.41859 21.0234 11.5272 21.0234Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <rect x="8.27722" y="1.23926" width="7" height="16" fill="transparent"/>
    <path d="M11.7772 2.36426V14.0518" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
)

export const PlusIcon = ({size, color}:IconInterface) => (
  <svg style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color?? COLORS.primaryBlack
  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
  </svg>
)


export const PlusCircleIcon = ({size, color}:IconInterface) => (
  <svg style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color?? COLORS.primaryBlack
  }}  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>

)

export const MinusIcon = ({size, color}:IconInterface) => (
  <svg style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color?? COLORS.primaryBlack
  }} width="21" height="2" viewBox="0 0 21 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.96875 0H20.9688V2H0.96875V0Z" fill="currentColor"/>
  </svg>

)


export const CreatedIcon = ({size, color}:IconInterface) => (
  <svg style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color?? COLORS.primaryBlack
  }} width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M23.7549 38.5342C31.6838 38.5342 38.1114 32.1066 38.1114 24.1778C38.1114 16.2489 31.6838 9.82129 23.7549 9.82129C15.826 9.82129 9.39844 16.2489 9.39844 24.1778C9.39844 32.1066 15.826 38.5342 23.7549 38.5342Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M18.5549 23.0265C21.7972 25.0763 24.2197 28.7392 24.2197 28.7392H24.2684C24.2684 28.7392 29.4151 19.632 38.9765 14.031" stroke="#4B9C60" strokeWidth="2" strokeLinecap="square"/>
  </svg>
)

export const YourGallery = () =>(
  <svg style={{
    height:'125px',
    width:'157px'
  }} width="157" height="125" viewBox="0 0 157 125" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="156" height="124" transform="translate(0.828125 0.333008)" fill="#F9F9F9"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M77.085 32.8867C77.085 34.0226 76.1651 34.9424 75.0293 34.9424C73.8946 34.9424 72.9736 34.0226 72.9736 32.8867C72.9736 31.7509 73.8946 30.8311 75.0293 30.8311C76.164 30.8322 77.0838 31.752 77.085 32.8867Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M69.5176 45.0399L73.5271 39.7092H73.6407L76.467 42.2457H76.6718L80.988 35.9648H81.1453L87.4011 44.7892" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M87.6318 45.5615L87.6318 27.0615L69.1318 27.0615L69.1318 45.5615L87.6318 45.5615Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M62.9062 66.6143L65.2891 61.9111H67.8984L64.1094 68.8877V73.333H61.7031V68.9658L57.9141 61.9111H60.5391L62.9062 66.6143ZM77.0859 68.9502C77.0859 69.6794 76.987 70.3252 76.7891 70.8877C76.5964 71.4502 76.3125 71.9268 75.9375 72.3174C75.5677 72.7028 75.1198 72.9945 74.5938 73.1924C74.0729 73.3903 73.4844 73.4893 72.8281 73.4893C72.2135 73.4893 71.6484 73.3903 71.1328 73.1924C70.6224 72.9945 70.1771 72.7028 69.7969 72.3174C69.4219 71.9268 69.1302 71.4502 68.9219 70.8877C68.7188 70.3252 68.6172 69.6794 68.6172 68.9502C68.6172 67.9814 68.7891 67.1611 69.1328 66.4893C69.4766 65.8174 69.9661 65.307 70.6016 64.958C71.237 64.609 71.9948 64.4346 72.875 64.4346C73.6927 64.4346 74.4167 64.609 75.0469 64.958C75.6823 65.307 76.1797 65.8174 76.5391 66.4893C76.9036 67.1611 77.0859 67.9814 77.0859 68.9502ZM71.0469 68.9502C71.0469 69.5231 71.1094 70.0049 71.2344 70.3955C71.3594 70.7861 71.5547 71.0804 71.8203 71.2783C72.0859 71.4762 72.4323 71.5752 72.8594 71.5752C73.2812 71.5752 73.6224 71.4762 73.8828 71.2783C74.1484 71.0804 74.3411 70.7861 74.4609 70.3955C74.5859 70.0049 74.6484 69.5231 74.6484 68.9502C74.6484 68.3721 74.5859 67.8929 74.4609 67.5127C74.3411 67.1273 74.1484 66.8382 73.8828 66.6455C73.6172 66.4528 73.2708 66.3564 72.8438 66.3564C72.2135 66.3564 71.7552 66.5726 71.4688 67.0049C71.1875 67.4372 71.0469 68.0856 71.0469 68.9502ZM87.0703 64.5986V73.333H85.2422L84.9219 72.2158H84.7969C84.6094 72.5127 84.375 72.7549 84.0938 72.9424C83.8125 73.1299 83.5026 73.2679 83.1641 73.3564C82.8255 73.445 82.474 73.4893 82.1094 73.4893C81.4844 73.4893 80.9401 73.3799 80.4766 73.1611C80.013 72.9372 79.651 72.5908 79.3906 72.1221C79.1354 71.6533 79.0078 71.0439 79.0078 70.2939V64.5986H81.3906V69.7002C81.3906 70.3252 81.5026 70.7965 81.7266 71.1143C81.9505 71.432 82.3073 71.5908 82.7969 71.5908C83.2812 71.5908 83.6615 71.4814 83.9375 71.2627C84.2135 71.0387 84.4062 70.7132 84.5156 70.2861C84.6302 69.8538 84.6875 69.3278 84.6875 68.708V64.5986H87.0703ZM94.4453 64.4346C94.5651 64.4346 94.7031 64.4424 94.8594 64.458C95.0208 64.4684 95.151 64.484 95.25 64.5049L95.0703 66.7393C94.9922 66.7132 94.8802 66.695 94.7344 66.6846C94.5938 66.6689 94.4714 66.6611 94.3672 66.6611C94.0599 66.6611 93.7604 66.7002 93.4688 66.7783C93.1823 66.8564 92.9245 66.984 92.6953 67.1611C92.4661 67.333 92.2839 67.5622 92.1484 67.8486C92.0182 68.1299 91.9531 68.4762 91.9531 68.8877V73.333H89.5703V64.5986H91.375L91.7266 66.0674H91.8438C92.0156 65.7705 92.2292 65.4997 92.4844 65.2549C92.7448 65.0049 93.0391 64.807 93.3672 64.6611C93.7005 64.5101 94.0599 64.4346 94.4453 64.4346ZM56.1641 88.9189H60.6953V94.8408C60.0964 95.0387 59.474 95.1976 58.8281 95.3174C58.1823 95.432 57.4505 95.4893 56.6328 95.4893C55.4974 95.4893 54.5339 95.2653 53.7422 94.8174C52.9505 94.3695 52.349 93.708 51.9375 92.833C51.526 91.958 51.3203 90.8825 51.3203 89.6064C51.3203 88.4085 51.5495 87.3721 52.0078 86.4971C52.4714 85.6221 53.1458 84.945 54.0312 84.4658C54.9219 83.9867 56.0078 83.7471 57.2891 83.7471C57.8932 83.7471 58.4896 83.8122 59.0781 83.9424C59.6667 84.0726 60.2005 84.2419 60.6797 84.4502L59.875 86.3877C59.526 86.2106 59.1276 86.0622 58.6797 85.9424C58.2318 85.8226 57.763 85.7627 57.2734 85.7627C56.5703 85.7627 55.9583 85.9242 55.4375 86.2471C54.9219 86.57 54.5208 87.0231 54.2344 87.6064C53.9531 88.1846 53.8125 88.8669 53.8125 89.6533C53.8125 90.3981 53.9141 91.0596 54.1172 91.6377C54.3203 92.2106 54.6406 92.6611 55.0781 92.9893C55.5156 93.3122 56.0859 93.4736 56.7891 93.4736C57.1328 93.4736 57.4219 93.458 57.6562 93.4268C57.8958 93.3903 58.1198 93.3538 58.3281 93.3174V90.9346H56.1641V88.9189ZM66.8125 86.4189C67.9844 86.4189 68.8828 86.6742 69.5078 87.1846C70.1328 87.695 70.4453 88.471 70.4453 89.5127V95.333H68.7812L68.3203 94.1455H68.2578C68.0078 94.458 67.7526 94.7132 67.4922 94.9111C67.2318 95.109 66.9323 95.2549 66.5938 95.3486C66.2552 95.4424 65.8438 95.4893 65.3594 95.4893C64.8438 95.4893 64.3802 95.3903 63.9688 95.1924C63.5625 94.9945 63.2422 94.6924 63.0078 94.2861C62.7734 93.8747 62.6562 93.3538 62.6562 92.7236C62.6562 91.7965 62.9818 91.1143 63.6328 90.6768C64.2839 90.234 65.2604 89.9893 66.5625 89.9424L68.0781 89.8955V89.5127C68.0781 89.0544 67.9583 88.7184 67.7188 88.5049C67.4792 88.2913 67.1458 88.1846 66.7188 88.1846C66.2969 88.1846 65.8828 88.2445 65.4766 88.3643C65.0703 88.484 64.6641 88.6351 64.2578 88.8174L63.4688 87.208C63.9323 86.9632 64.4505 86.7705 65.0234 86.6299C65.6016 86.4893 66.1979 86.4189 66.8125 86.4189ZM68.0781 91.2861L67.1562 91.3174C66.3854 91.3382 65.849 91.4762 65.5469 91.7314C65.25 91.9867 65.1016 92.3226 65.1016 92.7393C65.1016 93.1038 65.2083 93.3643 65.4219 93.5205C65.6354 93.6715 65.9141 93.7471 66.2578 93.7471C66.7682 93.7471 67.1979 93.596 67.5469 93.2939C67.901 92.9919 68.0781 92.5622 68.0781 92.0049V91.2861ZM75.2891 95.333H72.9062V83.1768H75.2891V95.333ZM80.1797 95.333H77.7969V83.1768H80.1797V95.333ZM86.2891 86.4346C87.0964 86.4346 87.7917 86.5908 88.375 86.9033C88.9583 87.2106 89.4089 87.6585 89.7266 88.2471C90.0443 88.8356 90.2031 89.5544 90.2031 90.4033V91.5596H84.5703C84.5964 92.2314 84.7969 92.7601 85.1719 93.1455C85.5521 93.5257 86.0781 93.7158 86.75 93.7158C87.3073 93.7158 87.8177 93.6585 88.2812 93.5439C88.7448 93.4294 89.2214 93.2575 89.7109 93.0283V94.8721C89.2786 95.0856 88.8255 95.2419 88.3516 95.3408C87.8828 95.4398 87.3125 95.4893 86.6406 95.4893C85.7656 95.4893 84.9896 95.3278 84.3125 95.0049C83.6406 94.682 83.112 94.1898 82.7266 93.5283C82.3464 92.8669 82.1562 92.0335 82.1562 91.0283C82.1562 90.0075 82.3281 89.1585 82.6719 88.4814C83.0208 87.7992 83.5052 87.2887 84.125 86.9502C84.7448 86.6064 85.4661 86.4346 86.2891 86.4346ZM86.3047 88.1299C85.8411 88.1299 85.4557 88.2783 85.1484 88.5752C84.8464 88.8721 84.6719 89.3382 84.625 89.9736H87.9688C87.9635 89.6195 87.8984 89.3044 87.7734 89.0283C87.6536 88.7523 87.4714 88.5335 87.2266 88.3721C86.987 88.2106 86.6797 88.1299 86.3047 88.1299ZM97.0156 86.4346C97.1354 86.4346 97.2734 86.4424 97.4297 86.458C97.5911 86.4684 97.7214 86.484 97.8203 86.5049L97.6406 88.7393C97.5625 88.7132 97.4505 88.695 97.3047 88.6846C97.1641 88.6689 97.0417 88.6611 96.9375 88.6611C96.6302 88.6611 96.3307 88.7002 96.0391 88.7783C95.7526 88.8564 95.4948 88.984 95.2656 89.1611C95.0365 89.333 94.8542 89.5622 94.7188 89.8486C94.5885 90.1299 94.5234 90.4762 94.5234 90.8877V95.333H92.1406V86.5986H93.9453L94.2969 88.0674H94.4141C94.5859 87.7705 94.7995 87.4997 95.0547 87.2549C95.3151 87.0049 95.6094 86.807 95.9375 86.6611C96.2708 86.5101 96.6302 86.4346 97.0156 86.4346ZM98.1562 86.5986H100.766L102.414 91.5127C102.466 91.6689 102.51 91.8278 102.547 91.9893C102.583 92.1507 102.615 92.3174 102.641 92.4893C102.667 92.6611 102.688 92.8408 102.703 93.0283H102.75C102.781 92.7471 102.823 92.484 102.875 92.2393C102.932 91.9945 103.003 91.7523 103.086 91.5127L104.703 86.5986H107.258L103.562 96.4502C103.339 97.0544 103.047 97.557 102.688 97.958C102.328 98.3643 101.914 98.6689 101.445 98.8721C100.982 99.0752 100.471 99.1768 99.9141 99.1768C99.6432 99.1768 99.4089 99.1611 99.2109 99.1299C99.013 99.1038 98.8438 99.0752 98.7031 99.0439V97.1533C98.8125 97.1794 98.9505 97.2028 99.1172 97.2236C99.2839 97.2445 99.4583 97.2549 99.6406 97.2549C99.974 97.2549 100.26 97.1846 100.5 97.0439C100.74 96.9033 100.94 96.7132 101.102 96.4736C101.263 96.2393 101.391 95.9814 101.484 95.7002L101.625 95.2705L98.1562 86.5986Z" fill="#272728"/>
  </svg>
)

export const BuildHubGallery = ({color}:IconInterface) => (
  <svg style={{
    height:'125px',
    width:'157px',
  }} width="154" height="125" viewBox="0 0 154 125" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="153" height="124" transform="translate(0.828125 0.333008)" fill={"#F9F9F9"}/>
    <rect x="68.3281" y="27.7227" width="7" height="7" stroke={color ??"currentColor"} strokeWidth="1.5" strokeLinecap="square"/>
    <rect x="79.3271" y="27.7222" width="7" height="7" stroke={color ??"currentColor"} strokeWidth="1.5" strokeLinecap="square"/>
    <rect x="68.3281" y="38.7227" width="7" height="7" stroke={color ??"currentColor"} strokeWidth="1.5" strokeLinecap="square"/>
    <rect x="79.3281" y="38.7227" width="7" height="7" stroke={color ??"currentColor"} strokeWidth="1.5" strokeLinecap="square"/>
    <path d="M42.6016 61.9111H46.1562C47.6771 61.9111 48.8281 62.1247 49.6094 62.5518C50.3906 62.9788 50.7812 63.7288 50.7812 64.8018C50.7812 65.234 50.7109 65.6247 50.5703 65.9736C50.4349 66.3226 50.237 66.609 49.9766 66.833C49.7161 67.057 49.3984 67.2028 49.0234 67.2705V67.3486C49.4036 67.4268 49.7474 67.5622 50.0547 67.7549C50.362 67.9424 50.6068 68.2184 50.7891 68.583C50.9766 68.9424 51.0703 69.4215 51.0703 70.0205C51.0703 70.7132 50.901 71.307 50.5625 71.8018C50.224 72.2965 49.7396 72.6768 49.1094 72.9424C48.4844 73.2028 47.7396 73.333 46.875 73.333H42.6016V61.9111ZM45.0234 66.4346H46.4297C47.1328 66.4346 47.6198 66.3252 47.8906 66.1064C48.1615 65.8825 48.2969 65.5544 48.2969 65.1221C48.2969 64.6846 48.1354 64.3721 47.8125 64.1846C47.4948 63.9919 46.9896 63.8955 46.2969 63.8955H45.0234V66.4346ZM45.0234 68.3564V71.333H46.6016C47.3307 71.333 47.8385 71.1924 48.125 70.9111C48.4115 70.6299 48.5547 70.2523 48.5547 69.7783C48.5547 69.4971 48.4922 69.2497 48.3672 69.0361C48.2422 68.8226 48.0312 68.6559 47.7344 68.5361C47.4427 68.4163 47.0391 68.3564 46.5234 68.3564H45.0234ZM61.1797 64.5986V73.333H59.3516L59.0312 72.2158H58.9062C58.7188 72.5127 58.4844 72.7549 58.2031 72.9424C57.9219 73.1299 57.612 73.2679 57.2734 73.3564C56.9349 73.445 56.5833 73.4893 56.2188 73.4893C55.5938 73.4893 55.0495 73.3799 54.5859 73.1611C54.1224 72.9372 53.7604 72.5908 53.5 72.1221C53.2448 71.6533 53.1172 71.0439 53.1172 70.2939V64.5986H55.5V69.7002C55.5 70.3252 55.612 70.7965 55.8359 71.1143C56.0599 71.432 56.4167 71.5908 56.9062 71.5908C57.3906 71.5908 57.7708 71.4814 58.0469 71.2627C58.3229 71.0387 58.5156 70.7132 58.625 70.2861C58.7396 69.8538 58.7969 69.3278 58.7969 68.708V64.5986H61.1797ZM66.0625 64.5986V73.333H63.6797V64.5986H66.0625ZM64.875 61.1768C65.2292 61.1768 65.5339 61.2601 65.7891 61.4268C66.0443 61.5882 66.1719 61.8929 66.1719 62.3408C66.1719 62.7835 66.0443 63.0908 65.7891 63.2627C65.5339 63.4294 65.2292 63.5127 64.875 63.5127C64.5156 63.5127 64.2083 63.4294 63.9531 63.2627C63.7031 63.0908 63.5781 62.7835 63.5781 62.3408C63.5781 61.8929 63.7031 61.5882 63.9531 61.4268C64.2083 61.2601 64.5156 61.1768 64.875 61.1768ZM70.9531 73.333H68.5703V61.1768H70.9531V73.333ZM76.2266 73.4893C75.2526 73.4893 74.4583 73.109 73.8438 72.3486C73.2344 71.583 72.9297 70.4606 72.9297 68.9814C72.9297 67.4867 73.2396 66.3564 73.8594 65.5908C74.4792 64.82 75.2891 64.4346 76.2891 64.4346C76.7057 64.4346 77.0729 64.4919 77.3906 64.6064C77.7083 64.721 77.9818 64.8747 78.2109 65.0674C78.4453 65.2601 78.6432 65.4762 78.8047 65.7158H78.8828C78.8516 65.5492 78.8125 65.3044 78.7656 64.9814C78.724 64.6533 78.7031 64.3174 78.7031 63.9736V61.1768H81.0938V73.333H79.2656L78.8047 72.2002H78.7031C78.5521 72.4398 78.362 72.6585 78.1328 72.8564C77.9089 73.0492 77.6406 73.2028 77.3281 73.3174C77.0156 73.432 76.6484 73.4893 76.2266 73.4893ZM77.0625 71.5908C77.7135 71.5908 78.1719 71.3981 78.4375 71.0127C78.7083 70.6221 78.8516 70.0361 78.8672 69.2549V68.9971C78.8672 68.1481 78.737 67.4997 78.4766 67.0518C78.2161 66.5986 77.7318 66.3721 77.0234 66.3721C76.4974 66.3721 76.0859 66.5986 75.7891 67.0518C75.4922 67.5049 75.3438 68.1585 75.3438 69.0127C75.3438 69.8669 75.4922 70.5101 75.7891 70.9424C76.0911 71.3747 76.5156 71.5908 77.0625 71.5908ZM85.9688 61.1768V63.6533C85.9688 64.0856 85.9531 64.4971 85.9219 64.8877C85.8958 65.2783 85.875 65.5544 85.8594 65.7158H85.9844C86.1719 65.4137 86.3932 65.1689 86.6484 64.9814C86.9089 64.7939 87.1953 64.6559 87.5078 64.5674C87.8203 64.4788 88.1562 64.4346 88.5156 64.4346C89.1458 64.4346 89.6953 64.5465 90.1641 64.7705C90.6328 64.9893 90.9974 65.3356 91.2578 65.8096C91.5182 66.2783 91.6484 66.8877 91.6484 67.6377V73.333H89.2656V68.2314C89.2656 67.6064 89.151 67.1351 88.9219 66.8174C88.6927 66.4997 88.3385 66.3408 87.8594 66.3408C87.3802 66.3408 87.0026 66.4528 86.7266 66.6768C86.4505 66.8955 86.2552 67.221 86.1406 67.6533C86.026 68.0804 85.9688 68.6038 85.9688 69.2236V73.333H83.5859V61.1768H85.9688ZM102.117 64.5986V73.333H100.289L99.9688 72.2158H99.8438C99.6562 72.5127 99.4219 72.7549 99.1406 72.9424C98.8594 73.1299 98.5495 73.2679 98.2109 73.3564C97.8724 73.445 97.5208 73.4893 97.1562 73.4893C96.5312 73.4893 95.987 73.3799 95.5234 73.1611C95.0599 72.9372 94.6979 72.5908 94.4375 72.1221C94.1823 71.6533 94.0547 71.0439 94.0547 70.2939V64.5986H96.4375V69.7002C96.4375 70.3252 96.5495 70.7965 96.7734 71.1143C96.9974 71.432 97.3542 71.5908 97.8438 71.5908C98.3281 71.5908 98.7083 71.4814 98.9844 71.2627C99.2604 71.0387 99.4531 70.7132 99.5625 70.2861C99.6771 69.8538 99.7344 69.3278 99.7344 68.708V64.5986H102.117ZM107 61.1768V64.0049C107 64.333 106.99 64.6585 106.969 64.9814C106.953 65.3044 106.932 65.5544 106.906 65.7314H107C107.229 65.3721 107.542 65.0674 107.938 64.8174C108.333 64.5622 108.846 64.4346 109.477 64.4346C110.456 64.4346 111.25 64.8174 111.859 65.583C112.469 66.3486 112.773 67.471 112.773 68.9502C112.773 69.945 112.633 70.7809 112.352 71.458C112.07 72.1299 111.677 72.6377 111.172 72.9814C110.667 73.32 110.081 73.4893 109.414 73.4893C108.773 73.4893 108.268 73.3747 107.898 73.1455C107.529 72.9163 107.229 72.6585 107 72.3721H106.836L106.438 73.333H104.617V61.1768H107ZM108.711 66.3408C108.294 66.3408 107.964 66.4268 107.719 66.5986C107.474 66.7705 107.294 67.0283 107.18 67.3721C107.07 67.7158 107.01 68.1507 107 68.6768V68.9346C107 69.7835 107.125 70.4346 107.375 70.8877C107.625 71.3356 108.081 71.5596 108.742 71.5596C109.232 71.5596 109.62 71.333 109.906 70.8799C110.198 70.4268 110.344 69.7731 110.344 68.9189C110.344 68.0648 110.198 67.4215 109.906 66.9893C109.615 66.557 109.216 66.3408 108.711 66.3408ZM54.6641 88.9189H59.1953V94.8408C58.5964 95.0387 57.974 95.1976 57.3281 95.3174C56.6823 95.432 55.9505 95.4893 55.1328 95.4893C53.9974 95.4893 53.0339 95.2653 52.2422 94.8174C51.4505 94.3695 50.849 93.708 50.4375 92.833C50.026 91.958 49.8203 90.8825 49.8203 89.6064C49.8203 88.4085 50.0495 87.3721 50.5078 86.4971C50.9714 85.6221 51.6458 84.945 52.5312 84.4658C53.4219 83.9867 54.5078 83.7471 55.7891 83.7471C56.3932 83.7471 56.9896 83.8122 57.5781 83.9424C58.1667 84.0726 58.7005 84.2419 59.1797 84.4502L58.375 86.3877C58.026 86.2106 57.6276 86.0622 57.1797 85.9424C56.7318 85.8226 56.263 85.7627 55.7734 85.7627C55.0703 85.7627 54.4583 85.9242 53.9375 86.2471C53.4219 86.57 53.0208 87.0231 52.7344 87.6064C52.4531 88.1846 52.3125 88.8669 52.3125 89.6533C52.3125 90.3981 52.4141 91.0596 52.6172 91.6377C52.8203 92.2106 53.1406 92.6611 53.5781 92.9893C54.0156 93.3122 54.5859 93.4736 55.2891 93.4736C55.6328 93.4736 55.9219 93.458 56.1562 93.4268C56.3958 93.3903 56.6198 93.3538 56.8281 93.3174V90.9346H54.6641V88.9189ZM65.3125 86.4189C66.4844 86.4189 67.3828 86.6742 68.0078 87.1846C68.6328 87.695 68.9453 88.471 68.9453 89.5127V95.333H67.2812L66.8203 94.1455H66.7578C66.5078 94.458 66.2526 94.7132 65.9922 94.9111C65.7318 95.109 65.4323 95.2549 65.0938 95.3486C64.7552 95.4424 64.3438 95.4893 63.8594 95.4893C63.3438 95.4893 62.8802 95.3903 62.4688 95.1924C62.0625 94.9945 61.7422 94.6924 61.5078 94.2861C61.2734 93.8747 61.1562 93.3538 61.1562 92.7236C61.1562 91.7965 61.4818 91.1143 62.1328 90.6768C62.7839 90.234 63.7604 89.9893 65.0625 89.9424L66.5781 89.8955V89.5127C66.5781 89.0544 66.4583 88.7184 66.2188 88.5049C65.9792 88.2913 65.6458 88.1846 65.2188 88.1846C64.7969 88.1846 64.3828 88.2445 63.9766 88.3643C63.5703 88.484 63.1641 88.6351 62.7578 88.8174L61.9688 87.208C62.4323 86.9632 62.9505 86.7705 63.5234 86.6299C64.1016 86.4893 64.6979 86.4189 65.3125 86.4189ZM66.5781 91.2861L65.6562 91.3174C64.8854 91.3382 64.349 91.4762 64.0469 91.7314C63.75 91.9867 63.6016 92.3226 63.6016 92.7393C63.6016 93.1038 63.7083 93.3643 63.9219 93.5205C64.1354 93.6715 64.4141 93.7471 64.7578 93.7471C65.2682 93.7471 65.6979 93.596 66.0469 93.2939C66.401 92.9919 66.5781 92.5622 66.5781 92.0049V91.2861ZM73.7891 95.333H71.4062V83.1768H73.7891V95.333ZM78.6797 95.333H76.2969V83.1768H78.6797V95.333ZM84.7891 86.4346C85.5964 86.4346 86.2917 86.5908 86.875 86.9033C87.4583 87.2106 87.9089 87.6585 88.2266 88.2471C88.5443 88.8356 88.7031 89.5544 88.7031 90.4033V91.5596H83.0703C83.0964 92.2314 83.2969 92.7601 83.6719 93.1455C84.0521 93.5257 84.5781 93.7158 85.25 93.7158C85.8073 93.7158 86.3177 93.6585 86.7812 93.5439C87.2448 93.4294 87.7214 93.2575 88.2109 93.0283V94.8721C87.7786 95.0856 87.3255 95.2419 86.8516 95.3408C86.3828 95.4398 85.8125 95.4893 85.1406 95.4893C84.2656 95.4893 83.4896 95.3278 82.8125 95.0049C82.1406 94.682 81.612 94.1898 81.2266 93.5283C80.8464 92.8669 80.6562 92.0335 80.6562 91.0283C80.6562 90.0075 80.8281 89.1585 81.1719 88.4814C81.5208 87.7992 82.0052 87.2887 82.625 86.9502C83.2448 86.6064 83.9661 86.4346 84.7891 86.4346ZM84.8047 88.1299C84.3411 88.1299 83.9557 88.2783 83.6484 88.5752C83.3464 88.8721 83.1719 89.3382 83.125 89.9736H86.4688C86.4635 89.6195 86.3984 89.3044 86.2734 89.0283C86.1536 88.7523 85.9714 88.5335 85.7266 88.3721C85.487 88.2106 85.1797 88.1299 84.8047 88.1299ZM95.5156 86.4346C95.6354 86.4346 95.7734 86.4424 95.9297 86.458C96.0911 86.4684 96.2214 86.484 96.3203 86.5049L96.1406 88.7393C96.0625 88.7132 95.9505 88.695 95.8047 88.6846C95.6641 88.6689 95.5417 88.6611 95.4375 88.6611C95.1302 88.6611 94.8307 88.7002 94.5391 88.7783C94.2526 88.8564 93.9948 88.984 93.7656 89.1611C93.5365 89.333 93.3542 89.5622 93.2188 89.8486C93.0885 90.1299 93.0234 90.4762 93.0234 90.8877V95.333H90.6406V86.5986H92.4453L92.7969 88.0674H92.9141C93.0859 87.7705 93.2995 87.4997 93.5547 87.2549C93.8151 87.0049 94.1094 86.807 94.4375 86.6611C94.7708 86.5101 95.1302 86.4346 95.5156 86.4346ZM96.6562 86.5986H99.2656L100.914 91.5127C100.966 91.6689 101.01 91.8278 101.047 91.9893C101.083 92.1507 101.115 92.3174 101.141 92.4893C101.167 92.6611 101.188 92.8408 101.203 93.0283H101.25C101.281 92.7471 101.323 92.484 101.375 92.2393C101.432 91.9945 101.503 91.7523 101.586 91.5127L103.203 86.5986H105.758L102.062 96.4502C101.839 97.0544 101.547 97.557 101.188 97.958C100.828 98.3643 100.414 98.6689 99.9453 98.8721C99.4818 99.0752 98.9714 99.1768 98.4141 99.1768C98.1432 99.1768 97.9089 99.1611 97.7109 99.1299C97.513 99.1038 97.3438 99.0752 97.2031 99.0439V97.1533C97.3125 97.1794 97.4505 97.2028 97.6172 97.2236C97.7839 97.2445 97.9583 97.2549 98.1406 97.2549C98.474 97.2549 98.7604 97.1846 99 97.0439C99.2396 96.9033 99.4401 96.7132 99.6016 96.4736C99.763 96.2393 99.8906 95.9814 99.9844 95.7002L100.125 95.2705L96.6562 86.5986Z" fill={color ?? "#272728"}/>
  </svg>
)


export const StoreIcon = ({size, color}:IconInterface) => (
  <svg style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color?? COLORS.primaryBlack
  }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.48244 14.6869V21.7377H13.2661V14.6869M2.06768 7.3042L1.07227 12.3227V14.1062H22.7225V12.3227L21.5197 7.3042H2.06768Z" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M21.1885 14.521L21.1885 22.4014" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M1.73633 3.15625H22.3082" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
)

export const BellNotification = ({size, color}:IconInterface) => (
  <svg style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color?? COLORS.primaryBlack
  }}  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5" />
</svg>
)

export const PaperOrder = ({size, color}:IconInterface) => (
  <svg style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color?? COLORS.primaryBlack
  }}   xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z" />
</svg>

)

export const EditIcon = ({size, color}:IconInterface) => (
  <svg style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color?? COLORS.primaryBlack
  }} width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.2647 3.10059L21.1641 7.99997L8.06345 21.1006L3.16867 21.096L3.16406 16.2012L16.2647 3.10059Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
    <path d="M20.4863 21.0953L3.16895 21.0947" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
  </svg>
)

export const ClockIcon = ({size, color}:IconInterface) => (
  <svg
    style={{
      height:`${size ?? 20}px`,
      width:`${size ?? 20}px`,
      color: color?? COLORS.primaryBlack
    }}
    width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M21.082 12.874C21.082 17.983 16.941 22.124 11.832 22.124C6.72303 22.124 2.58203 17.983 2.58203 12.874C2.58203 7.76502 6.72303 3.62402 11.832 3.62402C16.941 3.62402 21.082 7.76502 21.082 12.874Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
    <path d="M15.2641 15.8162L11.4941 13.5672V8.72021" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
  </svg>
)

export const CalendarIcon = ({size, color}:IconInterface) => (
  <svg
    style={{
      height:`${size ?? 20}px`,
      width:`${size ?? 20}px`,
      color: color?? COLORS.primaryBlack
    }}
   xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />
</svg>

)

export const DollarIcon = ({size, color}:IconInterface) => (
  <svg style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color?? COLORS.primaryBlack
  }} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.20156 2 1.5 6.70156 1.5 12.5C1.5 18.2984 6.20156 23 12 23C17.7984 23 22.5 18.2984 22.5 12.5C22.5 6.70156 17.7984 2 12 2ZM12 21.2188C7.18594 21.2188 3.28125 17.3141 3.28125 12.5C3.28125 7.68594 7.18594 3.78125 12 3.78125C16.8141 3.78125 20.7188 7.68594 20.7188 12.5C20.7188 17.3141 16.8141 21.2188 12 21.2188ZM13.118 11.9562L12.5227 11.818V8.67031C13.4133 8.79219 13.9641 9.35 14.0578 10.0344C14.0695 10.1281 14.1492 10.1961 14.243 10.1961H15.2953C15.4055 10.1961 15.4922 10.1 15.4828 9.98984C15.3398 8.52969 14.1375 7.59219 12.532 7.43047V6.66406C12.532 6.56094 12.4477 6.47656 12.3445 6.47656H11.6859C11.5828 6.47656 11.4984 6.56094 11.4984 6.66406V7.4375C9.83906 7.59922 8.54062 8.51562 8.54062 10.2266C8.54062 11.8109 9.70781 12.575 10.9336 12.868L11.5125 13.0156V16.3602C10.4766 16.2219 9.89531 15.6688 9.77578 14.9234C9.76172 14.8344 9.68203 14.7687 9.59063 14.7687H8.50781C8.39766 14.7687 8.31094 14.8625 8.32031 14.9727C8.42578 16.2617 9.40313 17.4477 11.4891 17.6V18.3359C11.4891 18.4391 11.5734 18.5234 11.6766 18.5234H12.3422C12.4453 18.5234 12.5297 18.4391 12.5297 18.3336L12.525 17.5906C14.3602 17.4289 15.6727 16.4469 15.6727 14.6844C15.6703 13.0578 14.6367 12.3312 13.118 11.9562ZM11.5102 11.5766C11.3789 11.5391 11.2688 11.5039 11.1586 11.4594C10.3664 11.1734 9.99844 10.7117 9.99844 10.1164C9.99844 9.26562 10.643 8.78047 11.5102 8.67031V11.5766ZM12.5227 16.3672V13.2336C12.5953 13.2547 12.6609 13.2711 12.7289 13.2852C13.8375 13.6227 14.2102 14.0914 14.2102 14.8109C14.2102 15.7273 13.5211 16.2781 12.5227 16.3672Z" fill="currentColor"/>
  </svg>
)

export const BoxBox = ({size, color}:IconInterface) => (
  <svg
    style={{
      height:`${size ?? 20}px`,
      width:`${size ?? 20}px`,
      color: color?? COLORS.primaryBlack
    }}
    width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3.88965" width="7" height="7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
    <rect x="13.999" y="3.88916" width="7" height="7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
    <rect x="3" y="14.8896" width="7" height="7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
    <rect x="14" y="14.8896" width="7" height="7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
  </svg>
)

export const DocumentIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }}
    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
    className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round"
          d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"/>
  </svg>
)

export const OrderingIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }}
    width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5 2.5V14M4.5 14L2.5 12M4.5 14L6.5 12" stroke="currentColor" strokeLinecap="square"/>
    <path d="M11.5 13.5V2M11.5 2L9.5 4M11.5 2L13.5 4" stroke="currentColor" strokeLinecap="square"/>
  </svg>

)


export const CartIcon = ({size, color}:IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }} width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26.7904 21.9278H31.1643" stroke="currentColor" strokeWidth="2" strokeLinecap="square"/>
    <path fillRule="evenodd" clipRule="evenodd"
          d="M15.7953 36.7666C16.2701 36.7666 16.6534 37.1515 16.6534 37.6247C16.6534 38.0994 16.2701 38.4843 15.7953 38.4843C15.3205 38.4843 14.9373 38.0994 14.9373 37.6247C14.9373 37.1515 15.3205 36.7666 15.7953 36.7666Z"
          fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="square"/>
    <path fillRule="evenodd" clipRule="evenodd"
          d="M33.5863 36.7666C34.0611 36.7666 34.446 37.1515 34.446 37.6247C34.446 38.0994 34.0611 38.4843 33.5863 38.4843C33.1116 38.4843 32.7283 38.0994 32.7283 37.6247C32.7283 37.1515 33.1116 36.7666 33.5863 36.7666Z"
          fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="square"/>
    <path d="M12.4658 15.5256H38.0457L35.9676 31.2988H13.8875L11.7968 10.5156H7.75879" stroke="currentColor" strokeWidth="2"
          strokeLinecap="square"/>
  </svg>
)

export const Cancel = ({size, color}:IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? color
  }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.9667 4.03105L4.03114 11.9666" stroke={color ?? "#CE4848"} strokeWidth="1.5" strokeLinecap="square"
          strokeLinejoin="round"/>
    <path d="M11.972 11.9711L4.02889 4.02799" stroke={color ?? "#CE4848"} strokeWidth="1.5" strokeLinecap="square"
          strokeLinejoin="round"/>
  </svg>
)


export const Pending = ({size, color}:IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? color
  }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M7.81388 1.77209C11.2192 1.77209 13.9805 4.53276 13.9805 7.93876C13.9805 11.3441 11.2192 14.1054 7.81388 14.1054C4.40788 14.1054 1.64722 11.3441 1.64722 7.93876C1.64722 4.53276 4.40788 1.77209 7.81388 1.77209Z"
          stroke="#EB903D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.81063 5.4082V8.3542" stroke="#EB903D" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/>
    <path d="M7.81053 11.1361H7.8172" stroke="#EB903D" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/>
  </svg>

)


export const InProgress = ({size, color}:IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? color
  }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M14.0545 8.24931C14.0545 11.6553 11.2939 14.416 7.88786 14.416C4.48186 14.416 1.72119 11.6553 1.72119 8.24931C1.72119 4.84331 4.48186 2.08264 7.88786 2.08264C11.2939 2.08264 14.0545 4.84331 14.0545 8.24931Z"
          stroke="#257A95" strokeWidth="1.5" strokeLinecap="square"/>
    <path d="M10.1759 10.2108L7.6626 8.71144V5.4801" stroke="#257A95" strokeWidth="1.5" strokeLinecap="square"/>
  </svg>

)

export const Completed = ({size, color}:IconInterface) => (
  <svg style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color ?? color
  }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.18475 7.88932L6.85142 11.2227L13.3514 4.72266" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
)


export const InfoIcon = ({size, color}:IconInterface) => (
  <svg style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color?? COLORS.primaryBlack,
  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
  </svg>

)

export const MoreMenuIcon = ({size, color}:IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor"
    className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round"
          d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"/>
  </svg>
)

export const HamburgerMenu = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
    className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"/>
  </svg>

)



export const StarSolid = ({size, color}:IconInterface) => (
  <svg  style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color?? COLORS.primaryBlack
  }} width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.2219 4.51172L14.7229 10.3194L21.0192 10.9033L16.2687 15.0766L17.6589 21.2451L12.2219 18.0167L6.78491 21.2451L8.17518 15.0766L3.42465 10.9033L9.7209 10.3194L12.2219 4.51172Z" fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
)


export const Envelope = ({size, color}:IconInterface) => (
  <svg style={{
    height:`${size ?? 20}px`,
    width:`${size ?? 20}px`,
    color: color?? COLORS.primaryBlack
  }} width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M39.9758 14.5796L24.4376 26.885L8.89941 14.5796" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <rect x="8.89941" y="10.5156" width="31.0764" height="27.9687" stroke="currentColor" strokeWidth="2" strokeLinecap="square"/>
  </svg>
)

export const ChevronDown = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
       strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
  </svg>
)


export const CreditCardIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }}
    width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3.6875" y="4.9707" width="18.5" height="14.06" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
    <path d="M3.6875 9.7832H22.1875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
    <path d="M15.7891 15.3428H19.2643" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
    <path d="M11.5635 15.3418H12.3113" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
  </svg>
)

export const NotificationIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }}
    viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.74936 8.93778C6.74936 5.52036 9.51972 2.75 12.9371 2.75C16.3545 2.75 19.1249 5.52036 19.1249 8.93777V13.5184L20.7375 17.8572H5.13672L6.74936 13.5184V8.93778Z"
      stroke="currentColor" strokeWidth="1.5"/>
    <path
      d="M16.1048 17.8574V18.0834C16.1048 19.8323 14.6871 21.2501 12.9382 21.2501C11.1892 21.2501 9.77148 19.8323 9.77148 18.0834V17.8574"
      stroke="currentColor" strokeWidth="1.5"/>
  </svg>
)


export const LanguageIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }}
    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
    className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round"
          d="M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802"/>
  </svg>

)


export const PasswordChangeIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M11.6 12.0004C11.6 13.0234 10.771 13.8524 9.748 13.8524C8.725 13.8524 7.896 13.0234 7.896 12.0004C7.896 10.9774 8.725 10.1484 9.748 10.1484H9.751C10.772 10.1494 11.6 10.9784 11.6 12.0004Z"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
    <path d="M11.6025 12H17.9205V13.852" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
    <path d="M15.0923 13.852V12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
    <path fillRule="evenodd" clipRule="evenodd"
          d="M22.1606 21.25L22.1606 2.75L3.66064 2.75L3.66064 21.25L22.1606 21.25Z" stroke="currentColor" strokeWidth="1.5"
          strokeLinecap="round"/>
  </svg>
)

export const DeleteBinIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.88867 6.53418H20.6499L19.2325 21.3333H6.30607L4.88867 6.53418Z" stroke="#CE4848" strokeWidth="1.5"
          strokeLinecap="square"/>
    <path d="M17.2463 6.08035L16.1776 2.83301H9.36267L8.29395 6.08035" stroke="#CE4848" strokeWidth="1.5"
          strokeLinecap="square"/>
    <path d="M12.7705 11.4473L12.7705 16.4201" stroke="#CE4848" strokeWidth="1.5" strokeLinecap="square"/>
  </svg>
)
export const ArrowUpRightIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }}  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25" />
</svg>

)

export const SuccessIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }} width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M23.7559 38.2842C31.6847 38.2842 38.1124 31.8566 38.1124 23.9278C38.1124 15.9989 31.6847 9.57129 23.7559 9.57129C15.827 9.57129 9.39941 15.9989 9.39941 23.9278C9.39941 31.8566 15.827 38.2842 23.7559 38.2842Z"
          stroke="currentColor" strokeWidth="2" stroke-linecap="round"/>
    <path
      d="M18.5559 22.7765C21.7982 24.8263 24.2207 28.4892 24.2207 28.4892H24.2693C24.2693 28.4892 29.416 19.382 38.9775 13.781"
      stroke="#4B9C60" strokeWidth="2" stroke-linecap="square"/>
  </svg>
)


export const ErrorIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M23.8481 7.75781C32.7871 7.75781 40.0356 15.0046 40.0356 23.9453C40.0356 32.8843 32.7871 40.1328 23.8481 40.1328C14.9074 40.1328 7.66064 32.8843 7.66064 23.9453C7.66064 15.0046 14.9074 7.75781 23.8481 7.75781Z"
          stroke={color ?? COLORS.primaryBlack} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M23.8396 17.3027V25.036" stroke={color ?? COLORS.primaryBlack} strokeWidth="2" strokeLinecap="square"
          strokeLinejoin="round"/>
    <path d="M23.8394 32.3379H23.8569" stroke={color ?? COLORS.primaryBlack} strokeWidth="2" strokeLinecap="square"
          strokeLinejoin="round"/>
  </svg>
)



export const RefreshIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }}
  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
</svg>
)


export const NotificationRingIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }}
   xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5" />
</svg>

)


export const TruckIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }}
  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
</svg>
)

export const InternetIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }}
  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M8.288 15.038a5.25 5.25 0 017.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 011.06 0z" />
</svg>
)


export const SearchIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }}
   xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
</svg>
)


export const PersonIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }}
   xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
</svg>
)

export const GoogleIcon = (props:any) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
       width="20" height="20"
       viewBox="0 0 48 48">
    <path fill="#FFC107"
          d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path>
    <path fill="#FF3D00"
          d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path>
    <path fill="#4CAF50"
          d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path>
    <path fill="#1976D2"
          d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path>
  </svg>
)


export const FilterIcon = ({size, color}: IconInterface) => (
  <svg
    style={{
      height: `${size ?? 20}px`,
      width: `${size ?? 20}px`,
      color: color ?? COLORS.primaryBlack
    }}
    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
    className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round"
          d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75"/>
  </svg>

)




export const LoginIcon = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
       className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
</svg>

)


export const CameraIcon = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z" />
<path strokeLinecap="round" strokeLinejoin="round" d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z" />
</svg>
)


export const PersonAdd = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
</svg>
)


export const LockIcon = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
</svg>
)


export const MailOpenIcon = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M21.75 9v.906a2.25 2.25 0 01-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 001.183 1.981l6.478 3.488m8.839 2.51l-4.66-2.51m0 0l-1.023-.55a2.25 2.25 0 00-2.134 0l-1.022.55m0 0l-4.661 2.51m16.5 1.615a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V8.844a2.25 2.25 0 011.183-1.98l7.5-4.04a2.25 2.25 0 012.134 0l7.5 4.04a2.25 2.25 0 011.183 1.98V19.5z" />
</svg>

)


export const PhoneIcon = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
</svg>

)

export const ShareIcon = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
       className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round"
          d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"/>
  </svg>

)


export const ChevronRight = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
       className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"/>
  </svg>
)

export const ChevronLeft = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }}  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
</svg>

)

export const HomeIcon = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
       className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round"
          d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"/>
  </svg>
)

export const OrderIcon = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }}  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
</svg>

)


export const ContentIcon = ({size, color}: IconInterface) => (
  <svg style={{
    height: `${size ?? 20}px`,
    width: `${size ?? 20}px`,
    color: color ?? COLORS.primaryBlack
  }}  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3" />
</svg>
)










